import React, { useEffect, useState } from 'react';
import Calendar from './Calendar.jsx';

const DashBoard = ({ totalPoints }) => {
    const [allData, setAllData] = useState([]);

    useEffect(() => {
        // Retrieve all data from local storage
        const storedData = JSON.parse(localStorage.getItem('codingEntries')) || [];
        setAllData(storedData);
    }, [totalPoints]);

    // useEffect(() => {
    //     console.log({ allData });
    // }, [allData])

    // In the DashBoard component
    const markedDates = allData.map(entry => {
        return entry
    });

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                margin: "3rem 2rem",
            }}
        >
            <h1>Dashboard</h1>
            <hr />
            <Calendar markedDates={markedDates} />
        </div>
    );
};

export default DashBoard;
